import { useState } from "react";
import { Search, ChevronRight, X } from "lucide-react";
import { areaStyle } from "@/components/db/areaStyle";

export function AreasDrawer({ areas, onPick, onClose }) {
  const [q, setQ] = useState("");
  const list = areas.filter((a) => a.area.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="fixed inset-0 z-[90]" data-testid="areas-drawer">
      <div className="absolute inset-0 bg-slate-900/20" onClick={onClose} />
      <aside className="absolute right-0 top-0 h-full w-full max-w-xs bg-white shadow-2xl p-5 flex flex-col animate-in slide-in-from-right duration-200">
        <div className="font-head font-semibold text-[#1e2a5a]">Všetky oblasti</div>
        <div className="relative mt-3">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input data-testid="areas-drawer-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Hľadať oblasť…"
            className="w-full rounded-xl border border-slate-200 pl-8 pr-3 py-2 text-sm outline-none focus:border-violet-500" />
        </div>
        <ul className="mt-3 flex-1 overflow-y-auto space-y-0.5">
          {list.map((a) => {
            const { Icon, cls } = areaStyle(a.area);
            return (
              <li key={a.area}>
                <button data-testid={`drawer-area-${a.area}`} onClick={() => onPick(a.area)}
                  className="w-full flex items-center gap-3 rounded-xl px-2 py-2.5 text-left hover:bg-violet-50 transition-colors">
                  <span className={`inline-flex h-7 w-7 items-center justify-center rounded-lg ${cls}`}><Icon size={14} /></span>
                  <span className="flex-1 text-sm text-slate-700">{a.area}</span>
                  <span className={`text-xs font-semibold ${a.count ? "text-slate-700" : "text-slate-300"}`}>{a.count}</span>
                  <ChevronRight size={14} className="text-slate-400" />
                </button>
              </li>
            );
          })}
        </ul>
        <button data-testid="areas-drawer-close" onClick={onClose} className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-violet-700"><X size={15} /> Zavrieť</button>
      </aside>
    </div>
  );
}
